import React from 'react';
import InfoPage from '../InfoPage/InfoPage';
var NotFoundSkeleton = function () {
    return (React.createElement(InfoPage, { hideIcon: true, blockClass: "w-100" },
        React.createElement("h1", { className: "avenir-bold info-page-title" }, "404"),
        React.createElement("span", { className: "skeleton-line skeleton-h-md" }),
        React.createElement("span", { className: "skeleton-line skeleton-h-md w-50" }),
        React.createElement("span", { className: "skeleton-line skeleton-h-md w-75" })));
};
export default React.memo(NotFoundSkeleton);
